export default {
  namespaced: true,
  state () {
    return {
      days: [
        {
          title: 'Понедельник',
          start: '09:00',
          end: '22:00',
          weekend: false
        },
        {
          title: 'Вторник',
          start: '09:00',
          end: '22:00',
          weekend: false
        },
        {
          title: 'Среда',
          start: '09:00',
          end: '22:00',
          weekend: false
        },
        {
          title: 'Четверг',
          start: '09:00',
          end: '22:00',
          weekend: false
        },
        {
          title: 'Пятница',
          start: '09:00',
          end: '22:00',
          weekend: false
        },
        {
          title: 'Суббота',
          start: '09:00',
          end: '22:00',
          weekend: true
        },
        {
          title: 'Воскресенье',
          start: '09:00',
          end: '22:00',
          weekend: true
        }
      ]
    }
  }
}
